const ImagePicker = () => {
  const pages = [
    {
      page: 'Our Story',
      description: 'Company history & founding — helping healthcare professionals find their perfect space',
      options: [
        {
          label: 'Option A',
          url: 'https://images.unsplash.com/photo-1769698678497-c41f0ab47c3e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400',
          desc: 'Modern medical centre — glass facade exterior, professional healthcare building'
        },
        {
          label: 'Option B',
          url: 'https://images.unsplash.com/photo-1691507000305-c0006a062338?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400',
          desc: 'Grand glass entrance — impressive healthcare building exterior with soaring atrium'
        }
      ]
    },
    {
      page: 'Our Method',
      description: 'Strategy & process — how we find the right space for every practice',
      options: [
        {
          label: 'Option A',
          url: 'https://images.unsplash.com/photo-1746021375306-9dec0f637732?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400',
          desc: 'Modern clinic interior — open office with glass partitions, teal accents, natural light'
        },
        {
          label: 'Option B',
          url: 'https://images.unsplash.com/photo-1746021375258-79fa1464ca1f?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400',
          desc: 'Bright contemporary medical office — clean lines, open layout, professional space'
        }
      ]
    },
    {
      page: 'Our Team',
      description: 'Meet the professionals behind Spire Group',
      options: [
        {
          label: 'Option A',
          url: 'https://images.unsplash.com/photo-1758448721149-aa0ce8e1b2c9?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400',
          desc: 'Premium healthcare lobby — elegant reception desk, marble finishes, sophisticated design'
        },
        {
          label: 'Option B',
          url: 'https://images.unsplash.com/photo-1746021375246-7dc8ab0583f0?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400',
          desc: 'Professional medical practice space — bright open office with glass walls and plants'
        }
      ]
    },
    {
      page: 'Contact / Let\'s Connect',
      description: 'Reach out to start the conversation',
      options: [
        {
          label: 'Option A',
          url: 'https://images.pexels.com/photos/35438291/pexels-photo-35438291.jpeg?auto=compress&cs=tinysrgb&w=2400',
          desc: 'Welcoming dental office reception — warm, inviting, professional front desk'
        },
        {
          label: 'Option B',
          url: 'https://images.pexels.com/photos/33812025/pexels-photo-33812025.jpeg?auto=compress&cs=tinysrgb&w=2400',
          desc: 'Modern medical centre reception — warm wood panels, contemporary design'
        }
      ]
    }
  ];

  return (
    <div className="min-h-screen bg-gray-950 text-white p-8">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold mb-2 text-center">Hero Image Options</h1>
        <p className="text-gray-400 text-center mb-12">Pick one option per page — health & medical themed hero images</p>
        
        {pages.map((page, pi) => (
          <div key={pi} className="mb-16">
            <div className="mb-6">
              <h2 className="text-2xl font-bold text-purple-400">{page.page}</h2>
              <p className="text-gray-500 text-sm">{page.description}</p>
            </div>
            
            <div className="grid md:grid-cols-2 gap-6">
              {page.options.map((opt, oi) => (
                <div key={oi} className="group">
                  <div className="relative h-[280px] rounded-xl overflow-hidden">
                    <img 
                      src={opt.url}
                      alt={opt.desc}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute inset-0 bg-gradient-to-r from-purple-900/80 to-purple-800/60 flex items-center justify-center">
                      <div className="text-center px-6">
                        <h3 className="text-3xl md:text-4xl font-bold text-white mb-3">{page.page}</h3>
                        <p className="text-white/80 text-lg">Hero subtitle text preview</p>
                      </div>
                    </div>
                  </div>
                  <div className="mt-3 flex items-center gap-3">
                    <span className="bg-purple-600 text-white text-sm font-bold px-3 py-1 rounded-full">{opt.label}</span>
                    <span className="text-gray-300 text-sm">{opt.desc}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}

        <div className="fixed bottom-4 right-4 bg-yellow-500 text-black px-6 py-3 rounded-full font-bold shadow-2xl z-50">
          IMAGE PICKER
        </div>
      </div>
    </div>
  );
};

export default ImagePicker;
